import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import helperSpinner from "../../../../helpers/spinner";
import httpService from "../../../../services/httpServices/httpServices";
import helpersTime from "../../../../helpers/time";
import helpersNumber from "../../../../helpers/numbers";
import StateSiteUserPublisher from "./StateSiteUserPublisher";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function InfoSiteUserPublisher() {
  const params = useParams();
  const sitePublisherID = params.sitePublisherID;
  const [siteUserPublisher, setSiteUserPublisher] = useState();
  const [copied, setCopied] = useState(false);
  const history = useHistory();
  useEffect(() => {
    getSiteUserPublisher();
  }, []);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getSiteUserPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllSiteUserPublisher =
      await sendRequestGetSiteUserPublisher(sitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetAllSiteUserPublisher) {
      return;
    }

    const htmlTag = `<script class="hilite-script" data-hilite="${resultSendRequestGetAllSiteUserPublisher.hashIDScript}" src="https://unpkg.com/hilite-script-site-publisher@latest/dist/script.min.js"></script>`;

    setSiteUserPublisher({
      ...resultSendRequestGetAllSiteUserPublisher,
      htmlTag: htmlTag,
    });
  };

  const sendRequestGetSiteUserPublisher = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/publisher/site/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return resultRequest.data.data;
  };

  const setStateSitePublisher = async () => {
    const message = document.querySelector("#message").value;
    const state = document.querySelector("#state").value;
    const active = document.querySelector("#active").checked;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestSetStateSiteUserPublisher =
      await sendRequestSetStateSitePublisher(sitePublisherID, {
        message: message,
        state: state,
        active: active,
      });
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestSetStateSiteUserPublisher) {
      return;
    }

    history.push(
      `/user/manage/${siteUserPublisher.usp_user_id}/site-publisher`
    );
  };

  const sendRequestSetStateSitePublisher = async (
    sitePublisherID,
    dataFrom
  ) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/publisher/site/" +
          sitePublisherID,
        dataFrom,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateSiteUserPublisher = () => {
    return (
      <>
        <div className="text-left pb-2">
          <Link
            className="text-white"
            to={`/user/manage/${siteUserPublisher.usp_user_id}/site-publisher`}
          >
            <div className="btn btn-primary">
              <span>
                <span className="text-white">بازگشت</span>
              </span>
              <span className="pr-2">
                <i className="fas fa-arrow-left" aria-hidden="true"></i>
              </span>
            </div>
          </Link>
        </div>
        <div className="alert alert-warning ">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <span>
                {" "}
                خیلی مهم خیلی مهم خیلی مهم در صورت تایید سایت نمایش دهنده کاربر
                حتما قبل از تایید از طریق این
              </span>
              <span>
                {" "}
                <Link
                  className="d-inline"
                  target="_blank"
                  to="/manage/publishers/add"
                >
                  لینک
                </Link>
              </span>
              <span>
                {" "}
                سایت نمایش دهنده را به لیست سایت های نمایش دهنده اضافه کنید.
              </span>
            </li>
          </ul>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite m-0">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  <b>اطلاعات سایت نمایش دهنده کاربر</b>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره سایت نمایش دهنده</td>
                <td>{siteUserPublisher.usp_id}</td>
              </tr>
              <tr>
                <td>آدرس سایت</td>
                <td>
                  <a target="_blank" href={siteUserPublisher.usp_url}>
                    {siteUserPublisher.usp_url}
                  </a>
                </td>
              </tr>
              <tr>
                <td>شماره کاربر نمایش دهنده</td>
                <td>{siteUserPublisher.usp_user_id}</td>
              </tr>
              <tr>
                <td>حالت</td>
                <td>
                  {
                    StateSiteUserPublisher.statusSiteUserPublisherString()[
                      siteUserPublisher.usp_state
                    ]
                  }
                </td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  {
                    StateSiteUserPublisher.getActiveSiteUserPublisherString()[
                      siteUserPublisher.usp_active
                    ]
                  }
                </td>
              </tr>
              <tr>
                <td>پیغام</td>
                <td>{siteUserPublisher.usp_message}</td>
              </tr>
              <tr>
                <td>اسکریپت</td>
                <td dir="ltr" className="text-left">
                  <span className="pr-2">{siteUserPublisher.htmlTag}</span>
                  <span>
                    <button
                      className="btn btn-info"
                      onClick={(e) => {
                        e.preventDefault();
                        navigator.clipboard.writeText(
                          siteUserPublisher.htmlTag
                        );
                        setCopied(true);
                      }}
                    >
                      <i className="fas fa-copy pr-2"></i>
                      {copied ? "کپی شد" : " کپی  "}{" "}
                    </button>
                  </span>
                </td>
              </tr>
              <tr>
                <td>تاریخ درج</td>
                <td>
                  {helpersNumber.toPersianNum(
                    helpersTime.convertGregorianToJalali(
                      siteUserPublisher.usp_created_at
                    ) +
                      " " +
                      siteUserPublisher.usp_created_at.split(" ")[1]
                  )}
                </td>
              </tr>
              <tr>
                <td>تاریخ بروزرسانی</td>
                <td>
                  {helpersNumber.toPersianNum(
                    helpersTime.convertGregorianToJalali(
                      siteUserPublisher.usp_updated_at
                    ) +
                      " " +
                      siteUserPublisher.usp_updated_at.split(" ")[1]
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="pt-2">
          <form
            className="p-2 border border-1"
            onSubmit={(e) => {
              e.preventDefault();
              setStateSitePublisher();
            }}
          >
            <h1 className="text-dark"> تغییر حالت سایت نمایش دهنده</h1>
            <div className="py-2">
              <span>حالت : </span>
              <span className="d-inline-block">
                <select className="form-control" id="state">
                  <option value="2">تایید </option>
                  <option value="3">رد </option>
                </select>
              </span>
            </div>
            <div className="py-2">
              <div className="py-2">پیغام</div>
              <textarea
                className="form-control"
                id="message"
                rows="4"
              ></textarea>
            </div>
            <div className="py-2">
              <span className="pl-2">فعال :</span>
              <span>
                <label className="adl-switch">
                  <input
                    type="checkbox"
                    defaultChecked={siteUserPublisher.usp_active}
                    id="active"
                  />
                  <span className="adl-slider round"></span>
                </label>
              </span>
            </div>
            <div>
              <button className="btn btn-success">اعمال</button>
            </div>
          </form>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اطلاعات سایت نمایش دهنده کاربر
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {siteUserPublisher && generateSiteUserPublisher()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
